import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { useAuth } from "../../context/AuthContext";
import "./BottomNav.css";

export default function BottomNav() {
  const { cartCount, toggleCart } = useCart();
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Hide on certain pages to prioritize CTAs
  if (location.pathname.startsWith('/product/') || location.pathname === '/checkout' || location.pathname.startsWith('/admin')) return null;

  return (

    <div className="bottom-nav-wrapper mobile-only">
      <div className="bottom-nav">
        
        <NavLink to="/" className={({ isActive }) => `bn-item ${isActive ? "active" : ""}`}>
          <div className="bn-icon">
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
          </div>
          <span>Home</span>
        </NavLink>

        <NavLink to="/search" className={({ isActive }) => `bn-item ${isActive ? "active" : ""}`}>
          <div className="bn-icon">
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
               <circle cx="11" cy="11" r="8"></circle>
               <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
             </svg>
          </div>
          <span>Search</span>
        </NavLink>

        <NavLink to="/cart" className={({ isActive }) => `bn-item bn-cart ${isActive ? "active" : ""}`}>
          <div className="bn-icon">
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
               <circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle>
               <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
             </svg>
             {cartCount > 0 && <span className="bn-cart-badge">{cartCount}</span>}
          </div>
          <span>Cart</span>
        </NavLink>

        <NavLink to={isAuthenticated ? "/profile" : "/login"} className={({ isActive }) => `bn-item ${isActive ? "active" : ""}`}>
          <div className="bn-icon">
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          </div>
          <span>Account</span>
        </NavLink>

      </div>
    </div>
  );
}
